import { IMeta } from '@bees-web/core/types'
import { ChangeEvent } from 'react'
import {
  rateMyDeliveryChange,
  rateMyDeliveryResetState,
  trackDeliveryRatingModalViewed,
} from '../../actions/ratings'
import { doRequest } from '@bees-web/web-shared-services'

export const rateMyDeliverySubmittedThankYouMessage = (
  dispatch,
  interactiveState
) => ({
  attributes: {
    onDeferredLoad: (meta: IMeta) => {
      const submittedMessage =
        interactiveState.state.ratings.rateMyDelivery.score === 5
          ? meta.highScoreTranslate
          : meta.lowScoreTranslate

      dispatch(
        rateMyDeliveryChange({
          submittedMessage,
        })
      )
    },
  },
  text: interactiveState.state.ratings.rateMyDelivery.submittedMessage,
})

export const rateMyDelivery = (dispatch, interactiveState, globalActions) => ({
  attributes: {
    open: interactiveState.state.ratings.rateMyDelivery.isShowing,
    onDeferredLoad: async (meta: IMeta) => {
      try {
        const { order } = meta
        const accountId = encodeURIComponent(order.accountId)
        const locale = encodeURIComponent(order.locale)

        const response = await doRequest({
          endpoint: `ratings/pending?accountId=${accountId}&country=${locale}&page=0&pageSize=1&bypassDailyRule=true&numberOfRatings=5`,
          headers: {
            'Accept-Language': locale,
          },
        })
        const [pendingRating] = response?.data?.content || []
        const hasRatingPending = pendingRating?.useCaseType === 'ORDER'

        if (hasRatingPending) {
          const { orderNumber } = pendingRating?.metadata || {}
          const isNotRated =
            !interactiveState.state.ratings.rated.includes(orderNumber)

          dispatch(
            rateMyDeliveryChange({
              isShowing: isNotRated,
            })
          )
        }
      } catch (error) {
        console.error('Error loading Rate My Delivery data:', error)
      }
    },
    onClose: () => dispatch(rateMyDeliveryResetState),
    onLoad: (meta: IMeta) => {
      const { deliveryDate, orderId, vendorId, accountId } = meta

      dispatch(
        trackDeliveryRatingModalViewed({
          delivery_date: deliveryDate,
          order_id: orderId,
          poc_id: accountId,
          vendorId,
        })
      )
    },
  },
})

export const rateMyDeliverySurvey = (dispatch, interactiveState) => ({
  attributes: {
    question: interactiveState.state.ratings.rateMyDelivery.survey,
    onChange: (
      _e: ChangeEvent<HTMLInputElement>,
      _meta: IMeta,
      newOptions: any
    ) => {
      let mandatoryComment = false
      dispatch(
        rateMyDeliveryChange({
          answers: [
            {
              questionId:
                interactiveState.state.ratings.rateMyDelivery.survey.id,
              responses: newOptions.map((item) => {
                const filterOtherOption = newOptions.filter((option) => {
                  return (
                    option.optionKey ==
                    interactiveState.state.ratings.rateMyDelivery.survey.options
                      .length
                  )
                })
                mandatoryComment = !!filterOtherOption.length

                return item.optionKey
              }),
            },
          ],
          mandatoryComment,
        })
      )
    },
  },
})

export const rateMyDeliveryCommentTitle = (dispatch, interactiveState) => ({
  attributes: {
    text: ({ box_title }) => {
      if (interactiveState.state.ratings.rateMyDelivery.mandatoryComment)
        return box_title.substr(0, box_title.indexOf('(') - 1)
      return box_title
    },
  },
})

export const rateMyDeliveryVendorName = (dispatch, interactiveState) => ({
  attributes: {
    onDeferredLoad: (meta: IMeta) => {
      if (
        meta.vendorName !== 'undefined' &&
        meta.vendorName !== 'null' &&
        meta.vendorName !== ''
      ) {
        dispatch(
          rateMyDeliveryChange({
            showVendorName: true,
          })
        )
      }
    },
    visible: interactiveState.state.ratings.rateMyDelivery.showVendorName,
  },
})
